import * as React from "react";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import {
    // Tabs,
    Tab,
    Row,
    Col,
    Nav,
    Form,
    Button,
    Alert,
    // Spinner,
    InputGroup,
    Spinner,
    Container
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FaRegEyeSlash, FaRegEye } from 'react-icons/fa';

// Assets
import "../Assets/LoginPage.sass";
import "../Assets/custom_modal.css";

// Actions
import {
    authLogin,
    authSignUp,
    requestCompleted,
    authSuccess,
    IITBSSOLogin,
    googleLogin,
} from "Store/UserInfo/Actions";
import { Link, useNavigate } from "react-router-dom";
import log from "loglevel";
import { enableSignupConfirmation, enableSignupRollNo, signupRollNoLabel } from "Constants";


function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

class LoginPage_ extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            check: true,
            showSignUpConfirmationModal: false,
            confirmationModalData: null,
        };
    }

    componentDidMount() {
        const { error } = this.props;
        log.log("ERROR", error);
        this.props?.actions.requestCompleted();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showSignUpConfirmationModal !== this.state.showSignUpConfirmationModal) {
            this.firstName.current && (this.firstName.current.value = this.state.confirmationModalData?.firstName || "");
            this.lastName.current && (this.lastName.current.value = this.state.confirmationModalData?.lastName || "");
            this.email.current && (this.email.current.value = this.state.confirmationModalData?.email || "");
            this.password.current && (this.password.current.value = this.state.confirmationModalData?.password || "");
            this.confirmPassword.current && (this.confirmPassword.current.value = this.state.confirmationModalData?.password || "");
            if (enableSignupRollNo) {
                this.rollNo.current && (this.rollNo.current.value = this.state.confirmationModalData?.rollNo || "");
            }
        }

        if (this.props?.userInfo?.msg?.includes?.("Successfully registered.")) {
            this.firstName.current.value = ""
            this.lastName.current.value = ""
            this.email.current.value = ""
            this.password.current.value = ""
            this.confirmPassword.current.value = ""
            if (enableSignupRollNo) {
                this.rollNo.current.value = ""
            }
        }
    }

    onClick = () => {
        if (this.state.check === true) {
            this.setState({
                check: false
            });
        }
        else {
            this.setState({
                check: true
            });
        }
    };

    firstName = React.createRef();
    lastName = React.createRef();
    email = React.createRef();
    password = React.createRef();
    confirmPassword = React.createRef();
    rollNo = React.createRef();

    loginUsername = React.createRef();
    loginPassword = React.createRef();

    msg = React.createRef();
    error = React.createRef();

    handleSignUp = async (e) => {
        // TODO: Will use 'Link' once sign-up page is in new react
        e.preventDefault();
        log.log({ handleSignUp: "// TODO: Will use 'Link' once sign-up page is in new react" });
        let firstName = this.firstName.current.value.trim();
        let lastName = this.lastName.current.value.trim();
        let email = this.email.current.value.trim();
        let password = this.password.current.value.trim();
        let confirmPassword = this.confirmPassword.current.value.trim();
        let rollNo = this.rollNo.current ? this.rollNo.current.value.trim() : "";

        let error = null;
        let msg = null;

        let validationSuccesfull = false;

        log.log({ handleSignUp: { firstName, lastName, email, password, confirmPassword, error, msg } });

        if (firstName === "") {
            error = "Please enter valid firstname";
            displayGlobalMessage(error, "error");
        } else if (lastName === "") {
            error = "Please enter valid lastname";
            displayGlobalMessage(error, "error");
        } else if (email === "") {
            error = "Please enter valid email";
            displayGlobalMessage(error, "error");
        } else if (password === "") {
            error = "Please enter valid password";
            displayGlobalMessage(error, "error");
        } else if (password.length < 8) {
            error = "Password must be 8 or more characters long";
            displayGlobalMessage(error, "error");
        } else if (enableSignupRollNo && rollNo === "") {
            error = "Please enter valid " + signupRollNoLabel;
            displayGlobalMessage(error, "error");
        } else if (!(/([A-Z]+)/g.test(password))) {
            error = "Password must have at least 1 capital letter";
            displayGlobalMessage(error, "error");
        } else if (!(password.match(/[\W_]/))) {
            error = "Password must have at least 1 special character";
            displayGlobalMessage(error, "error");
        } else if (confirmPassword === "") {
            error = "Please re-enter your password in ConfirmPassword field";
            displayGlobalMessage(error, "error");
        } else if (password !== confirmPassword) {
            // error = "Password and Confirm Password are not same";
            error = "Passwords don't match";
            displayGlobalMessage(error, "error");
        } else {
            validationSuccesfull = true;
        }

        if (validationSuccesfull) {
            await this.finishSignUp({ email, firstName, lastName, password, rollNo, takeConfirmation: enableSignupConfirmation });
        } else {
            log.log({ handleSignUp: { error, msg } });
            this.props?.actions.requestCompleted(msg, error);
        }
    };

    editSignUpDetails = () => {
        this.setState({ showSignUpConfirmationModal: false });
    }

    finishSignUp = async ({ email, firstName, lastName, password, rollNo, takeConfirmation = false }) => {

        if (!takeConfirmation) {
            this.setState({ showSignUpConfirmationModal: false });
            const response = await this.props?.actions.authSignUp(
                email,
                firstName,
                lastName,
                password,
                rollNo
            );
            log.log({ authSignUp: response });
            // if (response.status === 200) {
            //     msg = response.data.msg;
            //     displayGlobalMessage(msg, "success");
            // } else {
            //     if (response.data && response.data.error) {
            //         error = response.data.error;
            //         displayGlobalMessage(error, "error");
            //     } else {
            //         log.log(response);
            //     }
            // }
        } else {
            this.setState({
                showSignUpConfirmationModal: true,
                confirmationModalData: {
                    email,
                    firstName,
                    lastName,
                    password,
                    rollNo,
                }
            });
        }
    }

    handleIITBSSOLogin = async (e) => {
        e.preventDefault();
        const _response = await this.props?.actions.IITBSSOLogin();
    };

    handleLogin = async (e) => {
        e.preventDefault();
        let loginUsername = this.loginUsername.current.value.trim();
        let loginPassword = this.loginPassword.current.value.trim();
        let error = null;
        let msg = null;

        if (loginUsername !== "root" && loginUsername !== "student" && (loginUsername === "" || !(loginUsername.match(/^[a-zA-Z0-9.\+\_\-]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/)))) {
            error = "Please enter valid email";
        } else if (loginPassword === "") {
            error = "Please enter valid password.";
        } else {
            const csrfToken = getCookie('csrftoken');
            log.log({ hello: this.props, csrfToken });
            const response = await this.props?.dispatch(this.props?.actions.authLogin(
                loginUsername,
                loginPassword,
                csrfToken
            ));
            log.log(" ===> ", response);
            if (response && response.status && response.status === 200) {
                msg = response.data.msg;
                // this.props?.navigate("/courseware/courseslist");
                // following so that load events get attached to window for statistics
                this.props?.actions.requestCompleted(msg, error);
                setTimeout(() => window.location.href = window.location.origin + "/courseware/courseslist", 300);
            } else if (response && response.status) {
                error = response.data;
                if (error === 'Forbidden 403') {
                    error = "User is not registered.";
                } else if (error.length > 50) {
                    error = "Something went wrong";
                }
            } else {
                error = response && response.data;
            }
            // if (response.status === 200) {
            //   error = response.data.error;
            //   msg = response.data.msg;
            //   this.props?.actions.authSuccess(
            //     response.data.username,
            //     response.data.token
            //   );
            // } else if (response.status === 201) {
            //   error = response.data.error;
            //   this.props?.actions.requestCompleted(msg, error);
            // } else {
            //   error = "Some unexpected problem happened";
            //   this.props?.actions.requestCompleted(msg, error);
            // }
        }
        log.log({ loginPassword, loginUsername, error, msg });
        this.props?.actions.requestCompleted(msg, error);
    };

    /*
    Google Login Methods
    reponse is response object that contains accessToken and tokenId
    send this tokenId to Backend for verification using googleLogin method
     */
    responseOnSuccess = (response) => {
        log.log("GOOGLE RESPONSE on Success");
        log.log(response);
        this.props?.actions.googleLogin(
            response.tokenId,
        );
    };

    responseOnFailure = (response) => {
        log.log("GOOGLE RESPONSE on Failure");
        log.log(response);
    };

    cleanMessage(msg, type) {
        log.log({ msg, type });
        if (typeof msg === "object") {
            if (type === "success") {
                return "Successful!";
            } else if (type === "error" && msg?.error) {
                return msg?.error;
            } else {
                return "Something went wrong, please try again!";
            }
        } else {
            return msg;
        }
    }

    render() {
        // const [checked, setChecked] = React.useState(true);
        // const icons = [FaRegEye, FaRegEyeSlash];
        if (this.props?.isAuthenticated) {
            window.location.href = "/courseware";
        }

        return (
            <Tab.Container defaultActiveKey="signin">
                <Row>
                    <Col>
                        <Alert
                            className={(this.props?.msg === null || this.props?.msg === undefined) ? "d-none" : ""}
                            variant={"success"}
                        >
                            {this.cleanMessage(this.props.msg, "success")}
                        </Alert>
                        <Alert
                            className={(this.props?.error === null || this.props?.error === undefined) ? "d-none" : ""}
                            variant={"danger"}
                        >
                            {this.cleanMessage(this.props.error, "error")}
                        </Alert>
                        <Container fluid>
                            <Row>
                                <Col>
                                    <Nav
                                        variant="tabs"
                                        className="d-flex flex-row justify-content-between w-100"
                                    >
                                        <Nav.Item className="d-flex" style={{ flexGrow: 1 }}>
                                            <Nav.Link eventKey="signin" className="w-100 text-center">
                                                Sign In
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item className="d-flex" style={{ flexGrow: 1 }}>
                                            <Nav.Link eventKey="Register" className="w-100 text-center">
                                                Register
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col sm={12}>
                                    <Tab.Content className="tab-content-responsive">
                                        <Tab.Pane eventKey="signin">
                                            <p className="text-center my-3" style={{ color: "gray" }}>
                                                Sign In to your Bodhitree Account
                                            </p>
                                            <Form>
                                                <Form.Group controlId="formBasicUsername">
                                                    <Form.Control
                                                        ref={this.loginUsername}
                                                        type="email"
                                                        id="emailID"
                                                        placeholder="Email"
                                                        className="my-3"
                                                        autoComplete="username"
                                                    />
                                                </Form.Group>

                                                <Form.Group controlId="formBasicPassword">
                                                    {/* <Form.Control
                                                    ref={this.loginPassword}
                                                    type="password"
                                                    placeholder="Password"
                                                    className="my-3"
                                                >
                                                </Form.Control> */}
                                                    <InputGroup>
                                                        <Form.Control
                                                            ref={this.loginPassword}
                                                            type={this.state.check ? "password" : "text"}
                                                            placeholder="Password"
                                                            id="passwordID"
                                                            autoComplete="current-password"
                                                        />
                                                        <Button variant="outline-secondary" onClick={this.onClick}>
                                                            {this.state.check ? <FaRegEye /> : <FaRegEyeSlash />}
                                                        </Button>
                                                    </InputGroup>
                                                </Form.Group>
                                                <div className=" text-right my-2">
                                                    <a href='javascript:void(0)' onClick={() => window.location.href = '/resetpassword'} className="my-3 modalDialog2">
                                                        Change/Forgot Password?
                                                    </a>
                                                    {/* <a href='javascript:void(0)' onClick={() => this.props?.handlerLogin()} className="my-3 modalDialog2">
                                                    Change/Forgot Password?
                                                </a> */}
                                                </div>

                                                <p className="text-center" style={{ color: "gray" }}>
                                                    By logging up, you agree to our <Link to="/terms">Terms of Use</Link> and
                                                    our <Link to={`/privacy`}>Privacy Policy</Link>.
                                                </p>
                                                <Button
                                                    variant="primary"
                                                    type="submit"
                                                    className="btn btn-block btn-lg my-3"
                                                    onClick={(e) => this.handleLogin(e)}
                                                    id="signIn"
                                                >
                                                    Sign In
                                                </Button>
                                                {/* <Button
                                                variant="primary"
                                                type="submit"
                                                className="btn btn-block btn-lg my-3"
                                                onClick={(e) => this.handleIITBSSOLogin(e)}
                                            >
                                                Sign in IITB SSO
                                            </Button>
                                            <DividerWithText>Or</DividerWithText>
                                            <div id="google-container" >
                                                <GoogleLogin
                                                    clientId="426536665174-0di6bf9pc6dujrim1j4obqa9n89afe8r.apps.googleusercontent.com"
                                                    render={renderProps => (
                                                        <button
                                                            onClick={renderProps.onClick}
                                                            disabled={renderProps.disabled}
                                                            type="button"
                                                            id="google-button"
                                                        >
                                                            <div id="google-div">
                                                                <img id="google-image" src="/public/images/googlelogo.svg" alt="" />
                                                                <span>Sigin With Google</span>
                                                            </div>
                                                        </button>
                                                    )}
                                                    buttonText="Login with Google"
                                                    onSuccess={this.responseOnSuccess}
                                                    onFailure={this.responseOnFailure}
                                                    cookiePolicy={'single_host_origin'}
                                                />
                                            </div> */}

                                                <div className="d-flex flex-column text-center">
                                                    <a
                                                        href='javascript:void(0)'
                                                        onClick={() => window.location.href = 'https://docs.google.com/document/d/10aLkiROkmA7a1LwesC7cCcCbB0FhLueOSzqQExws6KM/edit?usp=sharing'}
                                                        className="my-3"
                                                    >
                                                        Have trouble logging in? See login FAQ
                                                    </a>
                                                </div>
                                            </Form >
                                        </Tab.Pane >
                                        <Tab.Pane eventKey="Register">
                                            {
                                                this.state.showSignUpConfirmationModal ? <>
                                                    <p className="text-center mb-4" style={{ color: "gray" }}>
                                                        Please confirm your details once
                                                    </p>
                                                    <div className="d-flex flex-column align-items-start gap-2 w-100">
                                                        <p className="mb-0"><strong>First Name:</strong> {this.state.confirmationModalData?.firstName}</p>
                                                        <p className="mb-0"><strong>Last Name:</strong> {this.state.confirmationModalData?.lastName}</p>
                                                        <p className="mb-0"><strong>Email:</strong> {this.state.confirmationModalData?.email}</p>
                                                        {enableSignupRollNo ? <p className="mb-0"><strong>{signupRollNoLabel}:</strong> {this.state.confirmationModalData?.rollNo}</p> : null}
                                                        <p className="text-center mb-0" style={{ color: "gray" }}><em>password is intentionally kept hidden</em></p>
                                                    </div>
                                                    <div className="d-flex flex-row justify-content-center gap-2 mt-4">
                                                        {
                                                            this.props.loading ?
                                                                <Button
                                                                    variant="primary"
                                                                    className="btn btn-block btn-lg my-3 gap-3"
                                                                    disabled={this?.props.loading}
                                                                >
                                                                    <><Spinner size="sm" className="pr-2" animation="border" /> Signing up ...</>
                                                                </Button> :
                                                                <>
                                                                    <Button
                                                                        variant="outline-secondary"
                                                                        onClick={this.editSignUpDetails}
                                                                    >
                                                                        Edit Details
                                                                    </Button>
                                                                    <Button
                                                                        variant="primary"
                                                                        onClick={() => this.finishSignUp({
                                                                            email: this.state.confirmationModalData?.email,
                                                                            firstName: this.state.confirmationModalData?.firstName,
                                                                            lastName: this.state.confirmationModalData?.lastName,
                                                                            password: this.state.confirmationModalData?.password,
                                                                            rollNo: this.state.confirmationModalData?.rollNo,
                                                                            takeConfirmation: false
                                                                        })
                                                                        }
                                                                    >
                                                                        Confirm
                                                                    </Button>
                                                                </>
                                                        }
                                                    </div>
                                                </> : <>
                                                    <p className="text-center my-3" style={{ color: "gray" }}>
                                                        Create Your Bodhitree Account
                                                    </p>
                                                    <Form>
                                                        <Row>
                                                            <Col xs={12} md={6}>
                                                                <Form.Group controlId="formGridEmail" className="mb-0 pb-0">
                                                                    <Form.Control
                                                                        ref={this.firstName}
                                                                        required
                                                                        type="text"
                                                                        placeholder="First Name"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs={12} md={6}>
                                                                <Form.Group controlId="formGridLastName" className="mb-0 pt-0">
                                                                    <Form.Control
                                                                        ref={this.lastName}
                                                                        required
                                                                        type="text"
                                                                        placeholder="Last Name"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col>
                                                                <Form.Group controlId="formBasicEmail" className="mb-0">
                                                                    <Form.Control
                                                                        ref={this.email}
                                                                        required
                                                                        type="email"
                                                                        placeholder="Email"
                                                                        autoComplete="username"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>

                                                        {
                                                            enableSignupRollNo ? <Row>
                                                                <Col>
                                                                    <Form.Group controlId="formBasicRoll" className="mb-0">
                                                                        <Form.Control
                                                                            ref={this.rollNo}
                                                                            required
                                                                            type="text"
                                                                            placeholder={signupRollNoLabel}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row> : null
                                                        }

                                                        <Row>
                                                            <Col xs={12} md={6}>
                                                                <Form.Group controlId="formGridPassword" className="mb-0">
                                                                    <Form.Control
                                                                        ref={this.password}
                                                                        required
                                                                        type="password"
                                                                        placeholder="Password"
                                                                        autoComplete="new-password"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col xs={12} md={6}>
                                                                <Form.Group controlId="formGridConfirmPassword" className="mb-0">
                                                                    <Form.Control
                                                                        ref={this.confirmPassword}
                                                                        required
                                                                        type="password"
                                                                        placeholder="Confirm Password"
                                                                        autoComplete="new-password"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        <p className="text-center text-muted" style={{ fontSize: 12 }}>
                                                            Password Criteria: <br />
                                                            is at least 8 characters long,
                                                            has at least 1 capital letter and
                                                            has at least 1 special character
                                                        </p>
                                                        <p className="text-center" style={{ color: "gray" }}>
                                                            By signing up, you agree to our <Link to="/terms">Terms of Use</Link> and
                                                            our <Link to={`/privacy`}>Privacy Policy</Link>.
                                                        </p>
                                                        <Button
                                                            variant="primary"
                                                            type="submit"
                                                            className="btn btn-block btn-lg my-3"
                                                            onClick={(e) => this.handleSignUp(e)}
                                                            disabled={this?.props.loading}
                                                        >
                                                            {
                                                                this.props.loading ? <><Spinner size="sm" className="pr-2" animation="border" /> Signing up ...</> : "Sign Up"
                                                            }
                                                        </Button>
                                                    </Form>
                                                </>
                                            }

                                        </Tab.Pane>
                                    </Tab.Content >
                                </Col >
                            </Row >
                        </Container>
                    </Col >
                </Row >
            </Tab.Container >
        );
    }
}

const LoginPage = (props) => {
    const dispatch = useDispatch();

    const actions = {
        authLogin,
        authSignUp: (email, firstName, lastName, password, rollNo) => { dispatch(authSignUp(email, firstName, lastName, password, rollNo)); },
        authSuccess,
        requestCompleted: (msg, err) => dispatch(requestCompleted(msg, err)),
        IITBSSOLogin,
        googleLogin,
    };

    let userInfo = useSelector((state) => state.userInfo);

    const navigate = useNavigate();
    const state = {
        loading: userInfo.loading,
        username: userInfo.username,
        error: userInfo.error,
        msg: userInfo.msg,
        userInfo: userInfo,
    };

    return <LoginPage_ actions={actions} {...state} navigate={navigate} dispatch={dispatch} {...props} />;
};

export default LoginPage;
